<template lang="pug">
.story-medium
  .media
    .media-left(
      ref="thumbnail"
      data-toggle="tooltip"
      data-trigger="hover"
      data-container="body"
      :title="mediaFileName"
    )
      a.image(:href="url" target="_blank")
        img(v-if="fileType == 'image'" :src="small_thumb_url" width="100")
        i.fa.fa-file(v-if="fileType != 'image'")

    .media-body
      Label(:text="credit" v-if="credit")
      div {{ cutline }}
      a.media-filename.text-muted(:href="url" v-text="mediaFileName" v-if="filename")

      .text-right
        LabelledCheckbox(label="Print" :value="for_print")
        LabelledCheckbox(label="Web" :value="for_web")
</template>

<script>
  import { sync } from 'vuex-pathify'
  import { mediaFileName } from '@/utils/file_helpers'
  import LabelledCheckbox from '@/components/shared/labelled_checkbox.vue'
  import Label from '@/components/shared/label.vue'

  export default {
    components: {
      LabelledCheckbox,
      Label
    },

    props: {
      id: {
        type: Number,
        required: true
      }
    },

    data() {
      return {
        // This is a weird hack to make vue-pathify work with variable expansion.
        // See https://github.com/davestewart/vuex-pathify/issues/103.
        storeRootAttr: 'storyMedia'
      }
    },

    computed: {
      ...sync('storyMedia/:storeRootAttr@:id', [
        'use_as_content_for',
        'for_print',
        'for_web'
      ]),
      ...sync('storyMedia/:storeRootAttr@:id.medium', [
        'cutline',
        'credit',
        'url',
        'small_thumb_url',
        'file',
        'filename',
        'content_type'
      ]),

      fileType() {
        if(this.content_type != null) {
          return this.content_type.split('/')[0]
        }
      },

      mediaFileName() {
        return mediaFileName(this.filename)
      },
    },

    mounted() {
      if(this.$refs.thumbnail) {
        jQuery(this.$refs.thumbnail).tooltip()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .story-medium {
    margin-bottom: 20px;

    .media-filename {
      max-width: 250px;
      overflow: hidden;
    }
  }

  .media-left {
    a.image {
      position: relative;
      display: block;
    }
  }
</style>
